import { execOnLoad } from '@general/helpers';
import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import { closeModal, openModal } from '@components/modals';
import { initProductForm } from '@components/product';
import { openMinicart } from '@components/minicart';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (context) => {
  const snippetContainer = context.classList.contains('product-tile__container')
    ? context
    : context.closest('.product-tile__container');
  if (!snippetContainer || snippetContainer.classList.contains('product-tile__container--initialized')) return;

  const swiperWrapper = snippetContainer.querySelector('.product-tile__gallery .swiper-wrapper');
  if (swiperWrapper && swiperWrapper.querySelectorAll('.swiper-slide').length > 1) {
    const swiperContainer = swiperWrapper.closest('.product-tile__gallery');
    const pagination = swiperContainer.querySelector('.product-tile__gallery-pagination');
    const options = {
      modules: [EffectFade, Navigation, ...(pagination ? [Pagination] : [])],
      crossFade: true,
      effect: 'fade',
      navigation: {
        prevEl: swiperContainer.querySelector('.product-tile__gallery-arrow--left'),
        nextEl: swiperContainer.querySelector('.product-tile__gallery-arrow--right'),
      },
      ...(pagination
        ? {
            pagination: {
              el: pagination,
            },
          }
        : {}),
    };
    var autoChange = true;
    var changeEnter = false;
    var changeLeave = false;
    const swiper = new Swiper(swiperContainer, options);
    snippetContainer.addEventListener('mouseenter', () => {
      if (window.innerWidth <= parseInt(breakpoints.lg) || !autoChange) return;
      changeEnter = true;
      swiper.slideTo(1, 800);
    });

    snippetContainer.addEventListener('mouseleave', () => {
      if (window.innerWidth <= parseInt(breakpoints.lg) || !autoChange) return;
      changeLeave = true;
      swiper.slideTo(0, 800);
    });

    swiper.on('slideChangeTransitionStart', () => {
      if (!changeEnter && !changeLeave) {
        autoChange = false;
        return;
      }
      if (changeEnter) changeEnter = false;
      if (changeLeave) changeLeave = false;
    });
  }

  const quickBuy = snippetContainer.querySelector('.product-tile__quick-buy');
  const quickBuyTrigger = quickBuy?.querySelector('.quick-buy__trigger');
  const quickBuyModal = quickBuy?.querySelector('.quick-buy__modal');
  const quickBuyWrapper = document.querySelector('.quick-buy__wrapper');

  quickBuyTrigger?.addEventListener(
    'click',
    async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!quickBuyModal.classList.contains('open')) {
        if (!quickBuyWrapper.contains(quickBuy)) {
          await quickBuyWrapper.appendChild(quickBuyModal);
        }
        await openModal(quickBuyModal);
      }
    },
    { capture: true },
  );

  function restoreQuickBuy() {
    if (quickBuy && quickBuyModal) {
      quickBuy.appendChild(quickBuyModal);
    }
  }

  if (quickBuyModal) {
    quickBuyModal.addEventListener('transitionend', () => {
      if (!quickBuyModal.classList.contains('open')) {
        restoreQuickBuy();
      }
    });
  }

  function addDesktopHoverListeners() {
    snippetContainer.addEventListener('mouseenter', onMouseEnter);
    snippetContainer.addEventListener('mouseleave', onMouseLeave);
  }

  function removeDesktopHoverListeners() {
    snippetContainer.removeEventListener('mouseenter', onMouseEnter);
    snippetContainer.removeEventListener('mouseleave', onMouseLeave);
  }

  function onMouseEnter() {
    quickBuyModal.classList.add('open');
  }

  function onMouseLeave() {
    quickBuyModal.classList.remove('open');
  }

  if (quickBuyModal) {
    if (window.innerWidth > parseInt(breakpoints.lg)) {
      addDesktopHoverListeners();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth > parseInt(breakpoints.lg)) {
        restoreQuickBuy();
        addDesktopHoverListeners();
      } else {
        removeDesktopHoverListeners();
      }
    });
  }

  if (quickBuyModal) {
    const gallery = quickBuyModal.querySelector('.quick-buy__gallery-medias');
    const leftArrow = quickBuyModal.querySelector('.quick-buy__gallery-arrow--left');
    const rightArrow = quickBuyModal.querySelector('.quick-buy__gallery-arrow--right');
    const options = {
      loop: true,
      modules: [...(leftArrow && rightArrow ? [Navigation] : [])],
      ...(leftArrow && rightArrow
        ? {
            navigation: {
              prevEl: leftArrow,
              nextEl: rightArrow,
            },
          }
        : {}),
    };

    if (gallery && options) {
      const swiperGallery = new Swiper(gallery, options);
    }

    const form = quickBuyModal.querySelector('.product-tile__form');
    if (form) {
      const submit = form.querySelector('[type="submit"]');
      const errorWrapper = form.querySelector('.quick-buy__error-wrapper');
      const errorMessage = form.querySelector('.quick-buy__error [data-message]');

      initProductForm({
        form,
        callbacks: {
          beforeSubmit: () => {
            if (submit) submit.classList.add('loading');
          },
          afterSubmit: async () => {
            await closeModal(quickBuyModal);
            await await openMinicart(true);
            if (submit) submit.classList.remove('loading');
          },
          errorCallback: (err) => {
            if (submit) submit.classList.remove('loading');
            if (errorWrapper && errorMessage && err?.data?.message) {
              errorMessage.innerText = err.data.message;
              requestAnimationFrame(() => {
                errorWrapper.classList.add('shown');
                setTimeout(() => {
                  errorWrapper.classList.remove('shown');
                }, 3000);
              });
            }
          },
        },
      });
    }
  }
  snippetContainer.classList.add('product-tile__container--initialized');
};

execOnLoad(window.dAgency.initProductTile, '.product-tile__container');
